(function () {
  angular
    .module('specsguardApp')
    .controller('TemplateDialogCtrl', PveTemplateDialogCtrl);

  PveTemplateDialogCtrl.$inject = ['$scope', '$mdDialog', 'Labels'];

  function PveTemplateDialogCtrl ($scope, $mdDialog, Labels) {
    $scope.cancel = function () {
      $mdDialog.cancel();
    };
    $scope.LABELS = Labels;
    switch ($scope.type) {
      case 'create':
        $scope.title = $scope.LABELS.getLabel(`add${$scope.projectLevelKey}`);
        break;
      case 'copy':
        $scope.title = $scope.title = $scope.LABELS.getLabel(`copy${$scope.projectLevelKey}`);
        break;
    }

    $scope.submit = function () {
      $mdDialog.hide();
    };
  }
})();
